var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_70632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60494 24L36.3951 24C38.386 24 40 21.8925 40 19.2927V4.70726C40 2.10751 38.386 0 36.3951 0L3.60494 0C1.61399 0 0 2.10751 0 4.70726V19.2927C0 21.8925 1.61399 24 3.60494 24Z",
    fill: "#265183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23845 20.3125L33.7611 20.3125C35.3703 20.3125 36.6748 18.6091 36.6748 16.5079V7.48871C36.6748 5.38748 35.3703 3.68409 33.7611 3.68409L6.23845 3.68409C4.62926 3.68409 3.32477 5.38748 3.32477 7.48871V16.5079C3.32477 18.6091 4.62926 20.3125 6.23845 20.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3437 18.2383H30.8067C33.1641 18.2383 35.0752 16.5349 35.0752 14.4337V9.56433C35.0752 7.46309 33.1641 5.7597 30.8067 5.7597L25.3437 5.7597C22.9863 5.7597 21.0752 7.46309 21.0752 9.56433V14.4337C21.0752 16.5349 22.9863 18.2383 25.3437 18.2383Z",
    fill: "#265183"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_70632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentRight);
export default __webpack_public_path__ + "static/media/alignment-right.08d7fd1c01c176899567f5cb6c051684.svg";
export { ForwardRef as ReactComponent };